import { images } from "../../../../../assets";
import { LeftInfoModalProps } from "../../../../../components/left-info-modal/left-info-modal-layout";

export const MODAL_DELETE_DOC: Partial<LeftInfoModalProps> = {
  active: true,
  className: "error",
  img: images.IconEraseRed,
  mainTitle: "¿Quieres borrar este documento?",
  mainText: "Una vez borrado, no podrá volver a recuperarlo.",
  buttonText: "Eliminar",
};

export const MODAL_DOC_MAX_LIMIT: Partial<LeftInfoModalProps> = {
  active: true,
  className: "info",
  img: images.IconWarningYellow,
  mainTitle: "Aviso de documentación",
  mainText: "La documentación adjunta supera el máximo del tamaño establecido (5MB).",
  secondaryText: "Por favor, corrija antes de continuar.",
  buttonText: "Aceptar",
  noSecondaryButton: true,
};

export const MODAL_CHANGE_DOC: Partial<LeftInfoModalProps> = {
  active: true,
  className: "warning",
  img: images.IconWarningYellow,
  mainTitle: "¿Desea sustituir el documento existente por el seleccionado?",
  mainText: "Si continua con este proceso perderá el documento anterior.",
  buttonText: "Reemplazar",
  closeButtonText: "Cancelar",
};

export const MODAL_GET_DOCS_ERROR: Partial<LeftInfoModalProps> = {
  active: true,
  className: "error",
  img: images.IconWarningYellow,
  mainTitle: "Error",
  mainText:
    "No se ha recuperado el listado de los documentos obligatorios, por favor inténtelo más tarde",
  buttonText: "Aceptar",
  noMainButton: true,
  centerPrimaryButton: true,
};
